<div class="slide d-flex flex-column h-100">
  <div class="slide-header d-flex align-items-center justify-content-center text-white">
    <ng-content select="[slideHeader]"></ng-content>
  </div>

  <div class="slide-content d-flex flex-column justify-content-between h-100 bg-white p-3 pb-4">
    <ng-content></ng-content>
  </div>
</div>
